import Iconify from '@components/iconify';
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, SxProps, Theme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsive } from 'src/hooks/use-responsive';
import icons from 'src/utils/icons';

interface CustomDialogProps {
  onClose: () => void;
  open: boolean;
  title?: string | React.ReactNode;
  body: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  sx?: SxProps<Theme>;
  hideDivider?: boolean;
  hideCloseButton?: boolean;
  breakContent?: boolean;
  fullWidth?: boolean;
}

export default function CustomDialog({
  title,
  body,
  onClose,
  open,
  maxWidth = 'sm',
  sx,
  hideDivider = false,
  hideCloseButton = false,
  breakContent = false,
  fullWidth = false,
}: CustomDialogProps) {
  const onMobile = useResponsive('down', 'sm');
  const { t: eaa } = useTranslation('eaa');
  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onKeyDown={(e) => {
        if (e.key === 'Escape' && !hideCloseButton) onClose();
      }}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 0.8,
          minWidth: breakContent ? null : 'fit-content',
        },
        ...sx,
      }}
    >
      <DialogTitle
        variant="h4"
        sx={{
          textAlign: 'center',
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
        }}
      >
        {!hideCloseButton && (
          <Box display="flex" flexDirection="row-reverse" alignItems="center">
            <IconButton aria-label={eaa('aria.close')} onClick={onClose}>
              <Iconify width={20} icon={icons.commons.cross} />
            </IconButton>
          </Box>
        )}
        {title}
      </DialogTitle>
      {!hideDivider && <Divider sx={{ marginX: 4 }} />}
      <DialogContent sx={{ padding: onMobile ? 2 : 3 }}>{body}</DialogContent>
    </Dialog>
  );
}
